import { render, staticRenderFns } from "./Actualites.vue?vue&type=template&id=4a5b5a85&scoped=true&"
import script from "./Actualites.vue?vue&type=script&lang=ts&"
export * from "./Actualites.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5b5a85",
  null
  
)

export default component.exports